import { createAction, props } from '@ngrx/store';
import { IUserRolesResponse } from '../models/user-roles.model';

export const loadLegalEntityUserRoles = createAction('[StaticData] Load LegalEntityUserRoles');

export const loadLegalEntityUserRolesSuccess = createAction('[StaticData] Load LegalEntityUserRoles Success', props<{ response: IUserRolesResponse[] }>());

export const loadLegalEntityUserRolesFailure = createAction('[StaticData] Load LegalEntityUserRoles Failure', props<{ error: any }>());
